module.exports = __webpack_public_path__ + "static/redot6-d0597a97615fb54358cf812f614c7d30.gif";